module.exports =  [
    {
      text: 'Nom',
      value: 'name',
      sortable: false,
      multiple: false,
      multipleName: '',
      pointer: false,
      affichage: true,
      inputVisible: true,
      pointerName: '',
      width: '10',
      align: 'right'
    },
    {
      text: 'Description',
      value: 'description',
      sortable: false,
      multiple: false,
      multipleName: '',
      pointer: false,
      affichage: true,
      inputVisible: true,
      pointerName: '',
      width: '10',
      align: 'right'
    },
    {
      text: 'Total',
      value: 'total',
      sortable: false,
      multiple: false,
      multipleName: '',
      pointer: false,
      affichage: true,
      inputVisible: true,
      pointerName: '',
      width: '10',
      align: 'right'
    }
  ]